import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import CollectionModule from 'bundles/page-config-common/components/shared/CollectionModule';
import HomeSection from 'bundles/page-config-common/components/shared/HomeSection';
import { useHeaderLevel } from 'bundles/page-config-common/contexts/HeaderLevelContext';
import { useSkillClipsCollections } from 'bundles/page-config-common/contexts/enterprise/EnterpriseSkillClipsContext';

const EnterpriseSkillClipsModuleRenderer = () => {
  const { skillClipsLoading, skillClipsCollections } = useSkillClipsCollections();
  const { currentLevel, nextLevel } = useHeaderLevel();

  if (!skillClipsLoading && !skillClipsCollections?.length) {
    return null;
  }

  const finalCollections = skillClipsCollections?.map((collection) => ({
    ...collection,
    entities: collection.entities?.map((entity) => ({
      ...entity,
      titleComponent: nextLevel as 'h3' | 'h4',
    })),
  }));

  const enableEnterpriseHomeRefresh = GrowthDiscoveryEpicClient.preview('enableEnterpriseHomeRefresh');

  return (
    <HomeSection className="PageConfig_EnterpriseSkillClipsCollectionComponent">
      <CollectionModule
        isCollectionLoading={skillClipsLoading}
        collection={finalCollections?.[0]}
        disableNegativeMargins={enableEnterpriseHomeRefresh}
        disableCollectionPadding={enableEnterpriseHomeRefresh}
        customHeader={
          <Typography2 variant={enableEnterpriseHomeRefresh ? 'subtitleLarge' : 'titleSmall'} component={currentLevel}>
            {skillClipsCollections?.[0]?.title}
          </Typography2>
        }
      />
    </HomeSection>
  );
};

export default EnterpriseSkillClipsModuleRenderer;
